// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--13k2C","list":"_80ad21f8ef--list--RDn0q"};